import { Alert, Button, TextField } from '@cartly/ui';
import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { api } from '../../api/client';
import { useSubmit } from '../../app/hooks';
import { useSession } from '../../app/session';
import { AuthLayout } from '../../layouts/AuthLayout';

export function LoginPage() {
  const { refresh } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { pending, error, fieldErrors, run } = useSubmit();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const result = await run(() =>
      api.post<{ mfaRequired: boolean }>('/auth/login', { email, password }),
    );
    if (!result) return;
    await refresh();
    navigate(result.mfaRequired ? '/mfa' : from, { replace: true, state: { from } });
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back. Sign in to manage your stores and automations."
      footer={
        <>
          New to Cartly360? <Link to="/register">Create an account</Link>
        </>
      }
    >
      <form className="stack" onSubmit={onSubmit} noValidate>
        {error && <Alert tone="critical">{error}</Alert>}
        <TextField
          label="Email"
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={fieldErrors['email']}
        />
        <TextField
          label="Password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={fieldErrors['password']}
        />
        <div className="row-between">
          <span />
          <Link to="/forgot-password" className="text-sm">
            Forgot password?
          </Link>
        </div>
        <Button type="submit" variant="primary" block loading={pending}>
          Sign in
        </Button>
      </form>
    </AuthLayout>
  );
}
